import { RuleGuestAttributeResourceTypeRelation, RuleResourceTypeNotContainsOne } from "../../../shared/types";
import { RelationRuleValidator } from "./types";

export const relationNotContainsOne: RelationRuleValidator<
	RuleResourceTypeNotContainsOne<RuleGuestAttributeResourceTypeRelation>
> = {
	validate: (rule, value) => {
		if (value == null) {
			return false;
		}

		switch (rule.guestAttribute.entityType) {
			case "hotelStay.checkIn":
			case "hotelStay.checkOut":
			case "tenant":
			case "tags":
			case "groups":
			case "guestType":
			case "region":
			case "wave": {
				const ruleArray = Array.isArray(rule.value) ? rule.value : [rule.value];
				const valueArray = Array.isArray(value) ? value : [value];

				return !(ruleArray as string[]).some((v) => (valueArray as string[]).includes(v));
			}
			default:
				throw new Error("Not implemented rule");
		}
	},
};
